import { Outlet, useLocation } from 'react-router-dom';

import WebsiteV2Footer from '../components/WebsiteV2Footer';
import WebsiteV2Header from '../components/WebsiteV2Header';
import { useReferralAttribution } from '../referral';

export function WebsiteV2PublicLayout() {
  const location = useLocation();
  useReferralAttribution();

  const isHomepage = location.pathname === '/' || location.pathname === '/vnext';
  const showPreviewBadge = location.pathname === '/vnext';

  return (
    <div className="flex min-h-screen flex-col bg-[#f4efe7] text-slate-950">
      <WebsiteV2Header mode={isHomepage ? 'homepage' : 'content'} showPreviewBadge={showPreviewBadge} />
      <main className="flex-grow">
        <Outlet />
      </main>
      <WebsiteV2Footer />
    </div>
  );
}

export default WebsiteV2PublicLayout;
